import React from 'react';
import { get } from 'lodash';

import { Link } from 'libs/router';

import SystemMessage from './SystemMessage';

import { getSystemMessageContentLinkForBrand, getSystemMessageContentLinkForInfluencer } from 'utils/messenger';
import { __t, applyTranslations } from 'utils/language';

import type { Campaign, DeliverablesFilterCampaign } from 'types';

applyTranslations(require('./system-message.i18n.json'));

type Props = {
  time?: string,
  metadata: { postType: DeliverablesFilterCampaign },
  text: string,
  subcampaignId: number,
  campaign: Campaign,
  isBrand: boolean
};

class SystemChatMessageContentForApprovalReviewed extends SystemMessage<Props> {
  renderLink() {
    const { campaign, isBrand, subcampaignId, metadata } = this.props;
    const deliverableId = get(metadata, 'deliverable.id', null);
    const isCcm = campaign.campaignType === 'ccm';
    const link = isBrand
      ? getSystemMessageContentLinkForBrand(campaign.id, subcampaignId, deliverableId, metadata.postType || 'content_production', null, isCcm)
      : getSystemMessageContentLinkForInfluencer(campaign.id, subcampaignId, deliverableId, null, isCcm);

    return (
      <div>
        <Link
          to={link}
          className="system-chat-message__link system-chat-message__link--post"
        >
          {__t('system_message.button_messenger_view_results')}
        </Link>
      </div>
    );
  }

  render() {
    const { text, metadata } = this.props;
    const note = get(metadata, 'deliverable.brandFeedback', '');

    return (
      <React.Fragment>
        {this.renderIcon('magic-wand-inside-circle-custom-fg')}
        <div className="messages-system-message__container">
          <div className="messages-system-message__bubble">
            <div className="messages-system-message__heading">
              {text}
            </div>
            {
              note &&
                <div className="messages-system-message__paragraph">
                  {__t('system_message.system_message_note', { note })}
                </div>
            }
            {this.renderLink()}
          </div>
        </div>
        {this.renderFooter()}
      </React.Fragment>
    );
  }
}

export default SystemChatMessageContentForApprovalReviewed;
